import { FormattedMessage, useIntl } from "react-intl";
import Account from "../../../utils/apiConfig";
import ErrorHandler from "../../../utils/errorConfig";
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  IconButton,
  InputAdornment,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useState } from "react";
import { FetchAllUsers } from "@mikros/library";
import ApiServices from "../../../service/apiService";
import { format } from "date-fns";
import { saveAs } from "file-saver";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Alert } from "@mikros/shared-ui";

export interface SearchFilterUserProps {
  userData: FetchAllUsers;
  userDataFunction: Function;
  search: boolean;
  searchFunction: Function;
  totalCount: number;
  totalCountFunction: Function;
  formData: any;
  formDataFunction: Function;
  selectedLanguage: any;
  selectedLanguageFunction: Function;
  languages: any;
  selectedStatus: any;
  selectedStatusFunction: Function;
  hasMoreData?: Boolean;
  hasMoreDataFunction: Function;
}
export function SearchFilterUser(props: SearchFilterUserProps) {
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const intl = useIntl();
  const maxUserNameLimit = 50;
  const nameRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.,_/&\-#()]+$/);
  const workRegex: RegExp = new RegExp(/^[a-zA-Z0-9\s.,_/&#${}()\-\[\]]+$/);
  const emailRegex: RegExp = new RegExp(/\S+@\S+\.\S+/);
  const mobileRegex: RegExp = new RegExp(/^[0-9]{5,15}$/);
  const maxCharLimit = 50;
  const filterOptions = [
    { value: "active", label: intl.formatMessage({ id: "activeTrainees" }) },
    {
      value: "inactive",
      label: intl.formatMessage({ id: "inactiveTrainees" }),
    },
    { value: "all", label: intl.formatMessage({ id: "allTrainees" }) },
  ];
  const validators = {
    userNameValidator: (value: string) =>
      value === "" || nameRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "analytics.userView.userNameValidation",
          })}`,

    deptRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.departmentValidation",
          })}`,
    desgRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({
            id: "user.createUser.designationValidation",
          })}`,
    branchRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({ id: "user.createUser.branchValidation" })}`,
    locationRegexValidator: (value: string) =>
      !value
        ? ""
        : workRegex.test(value)
        ? ""
        : `${intl.formatMessage({ id: "user.createUser.locationValidation" })}`,
    // emailRegexValidator: (value: string) =>
    //   value
    //     ? emailRegex.test(value) 
    //       ? ""
    //       : `${intl.formatMessage({
    //           id: "user.createUser.emailValidation",
    //         })}`
    //     : "",
    // mobileRegexValidator: (value: string) =>
    //   value
    //     ? mobileRegex.test(value)
    //       ? ""
    //       : `${intl.formatMessage({
    //           id: "shareCustomer.mobileNumberValidation",
    //         })}`
    //     : "",
  };

  // const languages = ["English", "Hindi", "Tamil", "is empty"];
  const allValue = "All";
  // const [selectedStatus, setSelectedStatus] = useState("active");
  const [searchClicked, setSearchClicked] = useState<boolean>(false);
  const [downloadUserSuccess, setDownloadUserSuccess] =
    useState<boolean>(false);

  // const [selectedLanguage, setSelectedLanguage] = useState<string[]>([
  //   ...languages,
  // ]);

  const [errors, setErrors] = useState<Record<string, string>>({}); // Ensure it's an object

  const [errorFlag, setErrorFlag] = useState<boolean>(false);

  const toggleDownloadUserSuccess = () => {
    setDownloadUserSuccess(!downloadUserSuccess);
  };

  console.log("has more data in search filter user", props.hasMoreData);

  // const handleStatus = (event: {
  //   target: { value: SetStateAction<string> };
  // }) => {
  //   props.userStatusFunction(event.target.value);
  // };

  // function handleSearch() {}

  const columns = [
    {
      field: "userId",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.userId" }),
    },
    {
      field: "empId",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.employee" }),
    },
    {
      field: "userProfile.firstName",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.fname" }),
    },
    {
      field: "userProfile.lastName",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.lname" }),
    },
    {
      field: "email",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.email" }),
    },
    {
      field: "phNo",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.phNo" }),
    },
    {
      field: "dateOfJoin",
      title: intl.formatMessage({
        id: "user.searchUser.gridColumn.dateOfJoin",
      }),
    },
    {
      field: "userProfile.dob",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.dob" }),
    },
    {
      field: "lastWorkingDate",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.lastWorkingDate" }),
    },
    {
      field: "userProfile.gender",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.gender" }),
    },
    {
      field: "prefrdLanguage",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.language" }),
    },
    {
      field: "department",
      title: intl.formatMessage({
        id: "user.searchUser.gridColumn.department",
      }),
    },
    {
      field: "designation",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.desg" }),
    },
    {
      field: "location",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.location" }),
    },
    {
      field: "branchName",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.branch" }),
    },
    {
      field: "status",
      title: intl.formatMessage({ id: "user.searchUser.gridColumn.status" }),
    },
  ];

  //correct functioning of handleItem click
  const handleItemClick = (lang: string) => {
    let updatedSelection = [...props.selectedLanguage];
    if (lang === allValue) {
      updatedSelection = [...props.languages];
    } else {
      if (updatedSelection.includes(lang)) {
        updatedSelection = updatedSelection.filter((l) => l != lang);
      } else {
        updatedSelection.push(lang); //check
      }
    }
    if (updatedSelection.length === props.languages.length) {
      updatedSelection = [...props.languages];
    }
    // setSelectedLanguage(updatedSelection);
    props.selectedLanguageFunction(updatedSelection);
  };

  const renderValue = (selected: string[]) => {
    if (selected.length === props.languages.length) {
      return allValue;
    }
    return selected.join(",");
  };

  const formatDOJRequired = (dateString: any) => {
    const date = new Date(dateString);
    const formattedDate = format(date, "yyyy-MM-dd");
    return formattedDate;
  };
  const formatDOBRequired = (dateString: any) => {
    const date = new Date(dateString);
    const formattedDate = format(date, "yyyy-MM-dd");
    return formattedDate;
  };

  const formatGender = (gender: string) => {
    if (
      gender === intl.formatMessage({ id: "maleLang" }) ||
      gender === "male"
    ) {
      return "MALE";
    } else if (
      gender === intl.formatMessage({ id: "femaleLang" }) ||
      gender === "female"
    ) {
      return "FEMALE";
    } else {
      return "";
    }
  };

  const handleCSVDownload = async (): Promise<void> => {
    console.log("inside handleCSVDownload");

    try {
      const headers = columns.map((col) => col.title).join(",");
      const rows = props.userData.users.map((item: any) => {
        return columns
          .map((col) => {
            const value = col.field
              .split(".")
              .reduce((acc, part) => acc && acc[part], item);

            if (col.field === "dateOfJoin" && value) {
              return `"${formatDOJRequired(value)}"`; // Format dateOfJoin
            } else if (col.field === "userProfile.dob" && value) {
              return `"${formatDOBRequired(value)}"`; // Format DOB
            } else if (col.field === "userProfile.gender") {
              return `"${formatGender(value)}"`;
            } else {
              return `"${value || ""}"`; // Handle empty/null values
            }
          })
          .join(",");
      });

      const csvContent = [headers, ...rows].join("\n");

      // Create a Blob and trigger download
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, "users-data.csv");

      // Trigger success notification
      setTimeout(() => {
        toggleDownloadUserSuccess();
      }, 1000);
    } catch (error) {
      console.error("Error exporting CSV:", error);
    }
  };

  const handleSearch = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    console.log("Inside handle search:", props?.formData);

    // Map dropdown status values to API values
    const statusMapping: Record<string, string> = {
      active: "ACTIVE",
      inactive: "INACTIVE",
      all: "",
    };

    console.log("selected status", props.selectedStatus);
    const formattedStatus = statusMapping[props.selectedStatus] || "";
    console.log("formatted status", formattedStatus);

    // Check if at least one field has valid input (including status)
    setSearchClicked(true);

    // Define search filters **excluding `status`**
    const filters = [
      "firstName",
      "branchName",
      "department",
      "location",
      "designation",
      "email",
      "phNo",
    ];
    const isAllSelected =
      props.selectedLanguage.length === props.languages.length;
    // const isEmptySelected = selectedLanguage.includes("is empty");
    const languageQuery = isAllSelected
      ? ""
      : props.selectedLanguage
          .map((lang: string) => (lang === "is empty" ? "isEmpty" : lang)) // Replace "is empty" with "isEmpty"
          .join(",");

    const queryParams = [
      ...(isAllSelected || !languageQuery
        ? []
        : [`languages=${languageQuery}`]), //  Ensures language is omitted if all are selected
      ...(formattedStatus ? [`status=${formattedStatus}`] : []),
      ...filters
        .filter((key) => props.formData[key]?.trim())
        .map(
          (key) => `${key}=${encodeURIComponent(props.formData[key].trim())}`
        ),
    ].join("&");

    const apiUrl = `${accountInstance.accntId}/user/filter${
      queryParams ? `?${queryParams}` : ""
    }`;

    // console.log("Final Query String:", finalQueryString);
    console.log("API URL:", apiUrl);

    const api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api.makeRequest(apiUrl, "GET").then(async (data) => {
        if (data && data.errorMessage) {
          console.log("I entered error code handling in users");
          setErrorFlag(true);
          await errorInstance.updateErrorCode(data.errorMessage);
          return;
        } else {
          props?.userDataFunction(data);
          props.totalCountFunction(data?.users?.length);
          props.searchFunction(true);
          const hasDataLeft = data?.lastKey !== null;
          if (props.hasMoreDataFunction) {
            props.hasMoreDataFunction(hasDataLeft);
          }
        }
      });
    }
  };

  const handleClear = (field: string) => {
    props.formDataFunction({
      ...props.formData,
      [field]: "",
    });

    setErrors((prev) => ({ ...prev, [field]: "" }));
  };
  const handleClearAll = () => {
    props.formDataFunction({
      designation: "", // Reset all fields to empty or their default value
      firstName: "",
      branchName: "",
      location: "",
      department: "",
      email: "",
      phNo: "",
    });
    setErrors({});

    if (searchClicked) {
      let api = ApiServices.getInstance();
      if (accountInstance.accntId) {
        api
          .makeRequest(
            // `${accountInstance.accntId}/user/filter`,
            `${accountInstance.accntId}/user?limit=20`,
            "GET"
          )
          .then(async (data) => {
            if (data && data.errorMessage) {
              console.log("I entered error code handling in users");
              setErrorFlag(true);
              await errorInstance.updateErrorCode(data.errorMessage);
              return;
            } else {
              props?.userDataFunction(data);
              props.totalCountFunction(data?.users?.length);
              // props.searchFunction(true);
              props.searchFunction(false);
              // setSelectedLanguage([allValue]);
              // setSelectedStatus("active");

              props.selectedLanguageFunction([allValue]);

              props.selectedStatusFunction("active");
              handleItemClick(allValue);
              props.hasMoreDataFunction(true);
            }
          });
      }
      setSearchClicked(false); // Reset the search click status
    }
  };

  const handleChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    props.formDataFunction({
      ...props.formData,
      [name]: value,
    });

    console.log("inside handl change name", name);
    console.log("inside handle change value", value);
    // Validate and keep the error until the entire input is valid
    // const errorMsg = validators.userNameValidator(value);
    let errorMsg = "";
    if (name === "firstName") {
      console.log("inside user name validator");
      errorMsg = validators.userNameValidator(value);
    } else if (name === "branchName") {
      console.log("inside branch validator");
      errorMsg = validators.branchRegexValidator(value);
    } else if (name === "department") {
      console.log("inside dept validator");
      errorMsg = validators.deptRegexValidator(value);
    } else if (name === "location") {
      console.log("inside location validator");
      errorMsg = validators.locationRegexValidator(value);
    } else if (name === "designation") {
      console.log("inside desg validator");
      errorMsg = validators.desgRegexValidator(value);
    } else if (name === "phNo") {
      console.log("inside phNo validator");
      // errorMsg = validators.mobileRegexValidator(value);
    } else if (name === "email") {
      console.log("inside email validator");
      // errorMsg = validators.emailRegexValidator(value);
    }

    setErrors((prev: any) => ({
      ...prev,
      [name]: errorMsg, // Only update the specific field
    }));
  };

  return (
    <div>
      {downloadUserSuccess && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={intl.formatMessage({
              id: "users.searchUser.exportToCSVSuccess",
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"successShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgSuccess",
            })}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              toggleDownloadUserSuccess();
            }}
          />
        </Dialog>
      )}
      <Card sx={{ padding: 1, boxShadow: 3, borderRadius: 2 }}>
        <CardContent>
          <form onSubmit={handleSearch}>
            <div className="grid grid-cols-3 gap-2">
              {/* First Name Field */}
              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1">
                  <FormattedMessage id="analytics.userView.userName" />
                </Typography>
                <TextField
                  error={!!errors.firstName}
                  helperText={errors.firstName}
                  name="firstName"
                  value={props?.formData?.firstName}
                  onChange={handleChange}
                  inputProps={{ maxLength: maxUserNameLimit }}
                  InputProps={{
                    disableUnderline: true,
                    style: { backgroundColor: "white" },
                    endAdornment: props.formData.firstName && (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => handleClear("firstName")}
                          edge="end"
                          size="small"
                          sx={{
                            backgroundColor: "transparent",
                            "&:hover": { backgroundColor: "#E1E2E9" },
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>

              {/* Email Field */}
              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1">Email ID</Typography>
                <TextField
                  error={!!errors.email}
                  helperText={errors.email}
                  name="email"
                  value={props.formData.email}
                  onChange={handleChange}
                  inputProps={{ maxLength: maxCharLimit }}
                  InputProps={{
                    disableUnderline: true,
                    style: { backgroundColor: "white" },
                    endAdornment: props.formData.email && (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => handleClear("email")}
                          edge="end"
                          size="small"
                          sx={{
                            backgroundColor: "transparent",
                            "&:hover": { backgroundColor: "#E1E2E9" },
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>

              {/* Mobile Number Field */}
              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1">Mobile Number</Typography>
                <TextField
                  error={!!errors.phNo}
                  helperText={errors.phNo}
                  name="phNo"
                  value={props.formData.phNo}
                  onChange={handleChange}
                  inputProps={{ maxLength: maxCharLimit }}
                  InputProps={{
                    disableUnderline: true,
                    style: { backgroundColor: "white" },
                    endAdornment: props.formData.phNo && (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => handleClear("phNo")}
                          edge="end"
                          size="small"
                          sx={{
                            backgroundColor: "transparent",
                            "&:hover": { backgroundColor: "#E1E2E9" },
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </div>

            {/* Second Row */}
            <div className="grid grid-cols-3 gap-2">
              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1">
                  <FormattedMessage id="analytics.userView.location" />
                </Typography>
                <TextField
                  error={!!errors.location}
                  helperText={errors.location}
                  name="location"
                  value={props.formData.location}
                  onChange={handleChange}
                  inputProps={{ maxLength: maxCharLimit }}
                  InputProps={{
                    disableUnderline: true,
                    style: { backgroundColor: "white" },
                    endAdornment: props.formData.location && (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => handleClear("location")}
                          edge="end"
                          size="small"
                          sx={{
                            backgroundColor: "transparent",
                            "&:hover": { backgroundColor: "#E1E2E9" },
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>

              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1">
                  <FormattedMessage id="analytics.userView.desg" />
                </Typography>
                <TextField
                  error={!!errors.designation}
                  helperText={errors.designation}
                  name="designation"
                  value={props.formData.designation}
                  onChange={handleChange}
                  inputProps={{ maxLength: maxCharLimit }}
                  InputProps={{
                    disableUnderline: true,
                    style: { backgroundColor: "white" },
                    endAdornment: props.formData.designation && (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => handleClear("designation")}
                          edge="end"
                          size="small"
                          sx={{
                            backgroundColor: "transparent",
                            "&:hover": { backgroundColor: "#E1E2E9" },
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>

              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1">Department</Typography>
                <TextField
                  error={!!errors.department}
                  helperText={errors.department}
                  name="department"
                  value={props.formData.department}
                  onChange={handleChange}
                  inputProps={{ maxLength: maxCharLimit }}
                  InputProps={{
                    disableUnderline: true,
                    style: { backgroundColor: "white" },
                    endAdornment: props.formData.department && (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => handleClear("department")}
                          edge="end"
                          size="small"
                          sx={{
                            backgroundColor: "transparent",
                            "&:hover": { backgroundColor: "#E1E2E9" },
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </div>

            {/* Third Row */}
            <div className="grid grid-cols-3 gap-2">
              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1">Branch</Typography>
                <TextField
                  error={!!errors.branchName}
                  helperText={errors.branchName}
                  name="branchName"
                  value={props.formData.branchName}
                  onChange={handleChange}
                  inputProps={{ maxLength: maxCharLimit }}
                  InputProps={{
                    disableUnderline: true,
                    style: { backgroundColor: "white" },
                    endAdornment: props.formData.branchName && (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => handleClear("branchName")}
                          edge="end"
                          size="small"
                          sx={{
                            backgroundColor: "transparent",
                            "&:hover": { backgroundColor: "#E1E2E9" },
                          }}
                        >
                          <ClearIcon fontSize="small" />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>

              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1">Status</Typography>
                <Select
                  // value={selectedStatus}
                  // onChange={(e) => setSelectedStatus(e.target.value)}

                  value={props.selectedStatus}
                  onChange={(e) => props.selectedStatusFunction(e.target.value)}
                  sx={{ backgroundColor: "var(--color-mk-white)" }}
                >
                  {filterOptions.map((option) => (
                    <MenuItem
                      key={option.value}
                      value={option.value}
                      sx={{
                        color: "var(--color-mk-very-dark-grey) !important",
                      }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              <FormControl margin="dense" sx={{ width: "16rem" }}>
                <Typography variant="subtitle1">Language</Typography>
                <Select
                  labelId="language-select-label"
                  id="language-select"
                  multiple
                  value={props.selectedLanguage}
                  onChange={handleChange}
                  // input={<OutlinedInput label="Language" />}
                  renderValue={renderValue}
                  // MenuProps={MenuProps}
                >
                  {/* "All" option */}
                  <MenuItem
                    disableRipple
                    key={allValue}
                    value={allValue}
                    onClick={() => handleItemClick(allValue)}
                  >
                    <Checkbox
                      disableRipple
                      checked={
                        props.selectedLanguage.length === props.languages.length
                      }
                      sx={{
                        "&.Mui-checked": { color: "var-mk-very-dark-grey" },
                      }}
                    />
                    <ListItemText primary={allValue} />
                  </MenuItem>

                  {/* Individual language options */}
                  {props.languages.map((lang: string) => (
                    <MenuItem
                      disableRipple
                      key={lang}
                      value={lang}
                      onClick={() => handleItemClick(lang)}
                    >
                      <Checkbox
                        disableRipple
                        checked={props.selectedLanguage.includes(lang)}
                      />
                      <ListItemText primary={lang} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>

            {/* Buttons Row */}
            <div className="flex justify-end items-end space-x-2 mt-3">
              <Button
                type="submit"
                variant="contained"
                sx={{
                  borderRadius: "8px",
                  textTransform: "capitalize",
                  color: "white",
                  backgroundColor: "#6464E5",
                  "&:hover": { backgroundColor: "#E1E2E9", color: "black" },
                }}
              >
                <FormattedMessage id="analytics.userView.search" />
              </Button>

              <Button
                type="button"
                variant="contained"
                sx={{
                  borderRadius: "8px",
                  textTransform: "capitalize",
                  color: "black",
                  backgroundColor: "#E1E2E9",
                  "&:hover": { backgroundColor: "#E1E2E9" },
                }}
                onClick={handleClearAll}
              >
                <FormattedMessage id="analytics.userView.clear" />
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
      <div className="flex justify-end items-end mt-6">
        <Button
          type="button"
          variant="contained"
          sx={{
            borderRadius: "8px",
            textTransform: "capitalize",
            color: "white",
            backgroundColor: "#6464E5",
            "&:hover": { backgroundColor: "#E1E2E9", color: "black" },
          }}
          onClick={handleCSVDownload}
        >
          <FormattedMessage id="users.searchUser.exportToCSV" />
        </Button>
      </div>
    </div>
  );
}
